// note, this is the priority:
// npm start: .env.development.local, .env.local, .env.development, .env
// npm run build: .env.production.local, .env.local, .env.production, .env
// npm test: .env.test.local, .env.test, .env (note .env.local is missing)
// see more on https://create-react-app.dev/docs/adding-custom-environment-variables

const plone_site_root = process.env.REACT_APP_plone_site;
const plone_endpoint = process.env.REACT_APP_server;

const conf =
{
    endpoints:
    {
        login: `${plone_endpoint}/@accounts-login`,
        logout: `${plone_endpoint}/@accounts-logout`,
        info: `${plone_endpoint}/@accounts-info`,
        lost_password: `${plone_endpoint}/@users/{USERID}/reset-password`,
        register_user: `${plone_endpoint}/@accounts-register_user`
    },
    plone_site: plone_site_root,
    server:
    {
        default_redirect_after_login: process.env.REACT_APP_default_redirect_after_login,
        default_redirect_logged: process.env.REACT_APP_default_redirect_logged,
        login: '/auth/login',
        logout: '/auth/logout'
    },
    resources:
    {
        header: process.env.REACT_APP_resources_header,
        footer: process.env.REACT_APP_resources_footer
    },
    route:
    {
        base: '/auth',
        login: 'login',
        logout: 'logout',
        userinfo: 'userinfo',
        forgot_password: 'forgot-password',
        reset_password: 'reset-password/:username/:token',
        register: 'register',
        impersonate:'impersonate',
    },
    DEBUG: (process.env.REACT_APP_DEBUG==='TRUE')
};

export default conf;
